/* eslint-disable */
const Fetch_NOTIFICATION = "Fetch_NOTIFICATION";

const initialState = [];

export const fetchNotification = (payload) => ({
  type: Fetch_NOTIFICATION,
  payload,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Fetch_NOTIFICATION:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
